/**
 * Catch-all 404 page for unmatched routes.
 */

import { Box, Button, Stack, Text, Title } from '@mantine/core'
import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <Box
      style={ {
        minHeight: '100vh',
        background: '#0B0F1A',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      } }
      p="xl"
    >
      <Stack
        gap="md"
        align="center"
      >
        <Title
          order={ 1 }
          c="white"
        >
          404
        </Title>
        <Text c="dimmed">That route doesn't go anywhere yet.</Text>
        <Button
          component={ Link }
          to="/games"
          variant="light"
        >
          Back to games
        </Button>
      </Stack>
    </Box>
  )
}
